import { useContext, useEffect, useMemo, useState } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import { NavLink, useNavigate } from "react-router-dom";
import { ClearCart } from "../../Helper/MyCart";
import "../../styles/ShopByBrands.css";
import { axiosGet } from "../../Apis/axiosMethods";

const ShopByBrands = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [suppliersLimit, setSuppliersLimit] = useState(24);
  const [oilCount, setOilCount] = useState(0);

  const { setMarqueeData } = useContext(ConfigContext);
  const navigate = useNavigate();
  const dir = localStorage.getItem("dir");

  const getBrandsWithStaticLogo = useMemo(() => {
    const filteredSuppliers = suppliers.filter(
      (sup) => sup.sup_total_available_parts > 0
    );

    const staticBrand = {
      sup_id: "static-oil",
      sup_brand: "Vortoil",
      sup_logo_name: "vortoil.png",
      sup_total_available_parts: 0,
      sup_warranty: null,
      isStatic: true
    };

    if (filteredSuppliers.length >= 16) {
      const result = [...filteredSuppliers];
      result.splice(15, 0, staticBrand);
      return result;
    }

    return [...filteredSuppliers, staticBrand];
  }, [suppliers]);

  useEffect(() => {

    const controller = new AbortController();

    const fetchSuppliers = async () => {
      try {
        const response = await axiosGet(`/Dashboard/GetSupplierBrands`, {
          status: 1,
          popular: 1,
          lang: "en",
          pc_id: localStorage.getItem("pc_id"),
        });

        if (response?.data?.success === false) {
          LogoutHandle();
          return;
        }

        const data = Array.isArray(response?.data?.data)
          ? response?.data?.data
          : [];

        setSuppliers(data);
        setMarqueeData(data);
        setOilCount(Number(response?.data?.vortoil_count) || 0);
      } catch (error) {
        if (
          error?.name !== "CanceledError" &&
          error?.code !== "ERR_CANCELED"
        ) {
          console.log("Error loading supplier brands:", error);
        }
      }
    };

    fetchSuppliers();

    return () => {
      controller.abort();
    };
  }, []);

  const LogoutHandle = () => {
    localStorage.clear();
    ClearCart();
    window.location = "/Login";
  };

  const handleBrandClick = (sup) => {
    window.scrollTo(0, 0);

    if (sup.isStatic) {
      navigate("/Spare-Parts/Oil");
      return;
    }

    navigate(
      `/Spare-Parts/PartsByBrand/${sup.sup_id}-${encodeURIComponent(
        sup.sup_brand
      )}`
    );
  };

  if (!getBrandsWithStaticLogo.length) {
    return null;
  }

  return (
    <section className="blog-section pb-0">
      <div className="container">
        <h3 className="brand-title">
          <span>GHAYAR AUTO PARTS STORE:</span> SHOP BY BRANDS
        </h3>

        <div className="row brand-grid">
          {getBrandsWithStaticLogo
            .slice(0, suppliersLimit)
            .map((sup, index) => {
              const shouldLoadImmediately = index < 8;

              if (sup.isStatic) {
                return (
                  <span
                    key={`static-oil-${index}`}
                    onClick={() => handleBrandClick(sup)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="brand-card">
                      <div className="brand-image-container">
                        <img
                          className="brand-image"
                          src="/assets/images/oil/vortoil.png"
                          alt="Vortoil"
                          loading={
                            shouldLoadImmediately ? "eager" : "lazy"
                          }
                          decoding="async"
                        />

                        {oilCount > 0 && (
                          <div className="parts-overlay d-flex gap-1 justify-content-center align-items-center">
                            <div
                              style={{
                                background: "#cc000b",
                                borderRadius: "50%",
                                color: "#FFF",
                                width: "40px",
                                height: "40px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "12px",
                                fontWeight: "bold"
                              }}
                            >
                              {oilCount}
                            </div>

                            <div
                              style={{
                                background: "#cc000b",
                                padding: "5px 10px",
                                borderRadius: "5px",
                                color: "#FFF",
                                marginLeft: "5px"
                              }}
                            >
                              Available Parts
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </span>
                );
              }

              return (
                sup.sup_brand && (
                  <span
                    key={`supplier-${sup.sup_id || index}`}
                    onClick={() => handleBrandClick(sup)}
                  >
                    <div className="brand-card">
                      {sup.sup_warranty && (
                        <img
                          src={`/assets/warrenty/${GetWarrantyImage(
                            sup.sup_warranty
                          )}`}
                          alt="Warranty"
                          loading={
                            shouldLoadImmediately ? "eager" : "lazy"
                          }
                          decoding="async"
                          className={
                            Number(sup.sup_id) === 358
                              ? "warranty-badge-left"
                              : "warranty-badge"
                          }
                        />
                      )}

                      {Number(sup.sup_id) === 475 && (
                        <img
                          src="/assets/images/banners/british_flag.gif"
                          alt="British flag"
                          loading={
                            shouldLoadImmediately ? "eager" : "lazy"
                          }
                          decoding="async"
                          className="supplier-special-badge"
                        />
                      )}

                      {[358, 4595].includes(Number(sup.sup_id)) && (
                        <img
                          src="/assets/images/banners/german_flag.gif"
                          alt="German flag"
                          loading={
                            shouldLoadImmediately ? "eager" : "lazy"
                          }
                          decoding="async"
                          className="supplier-special-badge"
                        />
                      )}

                      {sup.sup_total_available_parts > 0 && (
                        <div className="parts-overlay d-flex gap-1 justify-content-center align-items-center">
                          <div
                            style={{
                              background: "#cc000b",
                              borderRadius: "50%",
                              color: "#FFF",
                              width: "40px",
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "12px",
                              fontWeight: "bold"
                            }}
                          >
                            {sup.sup_total_available_parts}
                          </div>

                          <div
                            style={{
                              background: "#cc000b",
                              padding: "5px 10px",
                              borderRadius: "5px",
                              color: "#FFF",
                              marginLeft: "5px"
                            }}
                          >
                            Available Parts
                          </div>
                        </div>
                      )}

                      <ImageWithFallback
                        src={sup?.logo_url}
                        alt={sup.sup_brand}
                        fallbackText={sup.sup_brand}
                        eager={shouldLoadImmediately}
                      />
                    </div>
                  </span>
                )
              );
            })}
        </div>

        <br />

        {suppliers.length > 23 && (
          <center
            style={{
              direction: dir === "rtl" ? "ltr" : ""
            }}
          >
            <NavLink
              className="show-more-btn"
              onClick={() => {
                const totalBrands = getBrandsWithStaticLogo.length;

                setSuppliersLimit(
                  suppliersLimit === 24 ? totalBrands : 24
                );
              }}
            >
              {suppliersLimit === 24 ? "Show More" : "Show Less"}
            </NavLink>
          </center>
        )}
      </div>
    </section>
  );
};

const GetWarrantyImage = (warranty) => {
  switch (warranty) {
    case "1 Year":
      return "1_warrenty.gif";
    case "6 Months":
      return "6_mh_warrenty.gif";
    case "3 Years":
      return "3_years_warranty.png";
    default:
      return "1_year_warranty.png";
  }
};

const ImageWithFallback = ({
  src,
  alt,
  fallbackText,
  eager
}) => {
  const [imgError, setImgError] = useState(false);

  if (imgError || !src) {
    return (
      <div className="brand-image-container">
        <div className="fallback-text">{fallbackText}</div>
      </div>
    );
  }

  return (
    <div className="brand-image-container">
      <img
        className="brand-image"
        src={src}
        alt={alt}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        onError={() => setImgError(true)}
      />
    </div>
  );
};

export default ShopByBrands;